<ion-header>
  <ion-toolbar>
    <ion-title>Benachrichtigungen</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  
  <picture>
    <source *ngIf="darkmode.isDarkModeValue" srcset="/assets/Images/notification_request_light.png">
    <img src="/assets/Images/notification_request_dark.png" alt=""> 
  </picture>

  <h1>Bleiben Sie jederzeit auf dem Laufenden.</h1>
  <p>Werden Sie benachricht, sobald für Sie relevante Aktivitäten passieren.
  Dies kann beispielsweise eine <b>Ticketzuordnung</b>, ein <b>neuer Eintrag</b> oder ein <b>neuer Termin</b> sein.
  </p> 
  <p>Sie können dies in den Einstellungen wieder ändern.</p>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <div class="c-bttn main-button" (click)="close(true)">Benachrichtigungen aktivieren</div>
    <div class="c-bttn" (click)="close(false)">Jetzt nicht</div> 
  </ion-toolbar>
</ion-footer> 